import React from 'react';
const LanguageContext = React.createContext({});
export default LanguageContext;
